import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const ErrorBlock = ({ error, errors, type, withTranslate = true }) => {
  const renderErrors = useMemo(() => {
    if (errors && errors.length) {
      if (type === 'password') {
        return (
          <li className="sub-title-small-text message error">
            <Label message="Password does not meet requirements" />
          </li>
        );
      }
      return errors.map(error => {
        const { message, params } = error;
        const finalError = message || error;
        return (
          <li className="sub-title-small-text message error">
            {withTranslate ? <Label message={finalError} params={params} /> : finalError}
          </li>
        );
      });
    }
    if (error) {
      const isObjectError = error instanceof Object;
      const message = isObjectError ? error.message : error;
      const params = { ruleOption: isObjectError ? error.ruleOption : '' };

      return (
        <li className="sub-title-small-text message error">
          {withTranslate ? <Label message={message} params={params} /> : message}
        </li>
      );
    }

    return null;
  }, [type, errors, error, withTranslate]);

  if (renderErrors === null) {
    return null;
  }

  return <ul>{renderErrors}</ul>;
};

ErrorBlock.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  errors: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.string,
  withTranslate: PropTypes.bool,
};

export default ErrorBlock;
